export default __webpack_public_path__ + "static/media/EmptyHouse.9af11cee.svg";